import React from 'react';
import { BadgeDefinition } from '../../services/badgeService';
import './BadgeDisplay.css';

interface BadgeDisplayProps {
  badges: BadgeDefinition[];
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
  maxDisplay?: number;
}

const BadgeDisplay: React.FC<BadgeDisplayProps> = ({
  badges,
  size = 'medium',
  showTooltip = true,
  maxDisplay,
}) => {
  // Safety check for undefined badges
  const safeBadges = badges || [];
  const displayBadges = maxDisplay ? safeBadges.slice(0, maxDisplay) : safeBadges;
  const remainingCount =
    maxDisplay && safeBadges.length > maxDisplay ? safeBadges.length - maxDisplay : 0;

  if (safeBadges.length === 0) {
    return (
      <div className="badge-display empty">
        <span className="no-badges-text">No badges earned yet</span>
      </div>
    );
  }

  return (
    <div className={`badge-display ${size}`}>
      {displayBadges.map((badge, index) => (
        <div
          key={badge.id || index}
          className={`badge-item ${badge.category}`}
          title={showTooltip ? `${badge.name}: ${badge.description}` : undefined}
        >
          <span className="badge-icon">{badge.icon}</span>
          <span className="badge-name">{badge.name}</span>
        </div>
      ))}

      {remainingCount > 0 && (
        <div className="badge-item more-badges">
          <span className="badge-icon">+</span>
          <span className="badge-name">{remainingCount} more</span>
        </div>
      )}
    </div>
  );
};

export default BadgeDisplay;
